import { useEffect, useState } from "react";
import { AlertTriangle, ListPlus } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg, ts } from "@/lib/api";
import { btn } from "@/components/ui-kit";

export const UnmatchedDepots = ({ partner, rows, set }) => {
  const [list, setList] = useState(null);
  const [days, setDays] = useState(90);
  const [pick, setPick] = useState({});
  useEffect(() => {
    api.get(`/partners/${partner.code}/idoc/unmatched-depots`, { params: { days } })
      .then((r) => { setList(r.data.rows); setPick(Object.fromEntries(r.data.rows.map((d) => [d.gln, true]))); })
      .catch((e) => toast.error(errMsg(e)));
  }, [partner.code, days]);
  const have = new Set(rows.map((d) => (d.gln || "").trim().toUpperCase()));
  const todo = (list || []).filter((d) => !have.has(d.gln.toUpperCase()));
  const add = () => {
    const sel = todo.filter((d) => pick[d.gln]).map(({ gln, name, street, city, postcode }) => ({ gln, name, street, city, postcode, depot_code: "", sap_ship_to: "" }));
    set([...rows, ...sel]);
    toast.success(`${sel.length} depot(s) added below - enter each SAP ship-to, then Save`);
  };
  if (!list) return null;
  return (
    <div className="mb-3 rounded-sm border border-amber-500/40 bg-amber-500/10 p-3" data-testid="idoc-unmatched">
      <div className="mb-2 flex flex-wrap items-center gap-3 text-xs">
        <AlertTriangle className="h-4 w-4 text-amber-300" />
        <span className="font-semibold text-amber-200" data-testid="idoc-unmatched-count">{todo.length} delivery point(s) on orders from the last</span>
        <select value={days} onChange={(e) => setDays(Number(e.target.value))} className="h-7 rounded border border-slate-700 bg-[#17191F] px-1 text-xs text-slate-200" data-testid="idoc-unmatched-days">
          {[30, 90, 180, 365].map((d) => <option key={d} value={d}>{d} days</option>)}
        </select>
        <span className="text-amber-200">are not in the table</span>
        {todo.length > 0 && <Button size="sm" variant="ghost" onClick={add} className={`${btn.ghost} ml-auto`} data-testid="idoc-unmatched-add-btn"><ListPlus className="mr-1 h-3.5 w-3.5" /> Add selected to table</Button>}
      </div>
      {todo.length === 0 ? <p className="text-xs text-slate-400" data-testid="idoc-unmatched-none">Every delivery point on recent orders is in the table.</p> : (
        <div className="max-h-48 space-y-1 overflow-y-auto">
          {todo.map((d) => (
            <label key={d.gln} className="flex flex-wrap items-center gap-3 text-xs text-slate-300" data-testid={`idoc-unmatched-${d.gln}`}>
              <Checkbox checked={!!pick[d.gln]} onCheckedChange={(v) => setPick({ ...pick, [d.gln]: !!v })} data-testid={`idoc-unmatched-pick-${d.gln}`} />
              <span className="font-mono text-slate-100">{d.gln}</span><span>{d.name || "(no name)"}</span>
              <span className="text-slate-500">{[d.city, d.postcode].filter(Boolean).join(", ")}</span>
              <span className="text-slate-500">{d.orders} order(s), last {d.last_po} on {ts(d.last_at)}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};
